// import {parseHash} from "./metadata";
// import {getProbability} from "./elementData";
// import {tokenBlacklist} from "./tokenBlackList";
//
// import {get, readable, writable} from 'svelte/store';
import {
    onUnlocked,
    correct_network,
    target_mainnet, onInjected, provider
} from "./wallet.js";
//
// import {contractAddress,correctAddress ,first_block,state, contractAbi} from "./contracts";
//

import {get, writable} from "svelte/store";
import {infura_ready, onReady} from "./wallet-infura";
import {ethers} from "ethers";
import {cleanAddress, contractAbi} from "./contracts";
// import {_tokenMetadata, isInjected, tokenMetadata} from "./contracts-infura-old";

export let isInjected = false;

export let _drops = {};
export const drops = writable(_drops);

export let _pastDrops = [];
export let pastDrops = writable(_pastDrops);

export let useInfura = writable(true);
export let state_infura = writable('initial'); //initial, loading, loaded, network, error

export let _tokenMetadata = {};
export let tokenMetadata = writable(_tokenMetadata);


let dropTokenMetadataQueue = []; //chain
export async function requestDropTokenMetadata(tokenAddress,tokenId) {
    if(queueDropTokenMetadata(tokenAddress,tokenId)){
        if(dropTokenMetadataQueue.length === 1){
            fetchDropTokenMetadata();
        }
    }

    // tokenAddress = cleanAddress(tokenAddress);
    // tokenId = parseInt(tokenId);
    // let queueId = JSON.stringify([tokenAddress,tokenId]);
    //
    // if(
    //     (!_tokenMetadata[tokenAddress] || !_tokenMetadata[tokenAddress].tokens[tokenId])
    //         &&
    //     !dropTokenMetadataQueue.includes(queueId)
    // ){
    //     dropTokenMetadataQueue.splice(1,0,queueId);
    //     if(dropTokenMetadataQueue.length === 1){
    //         fetchDropTokenMetadata();
    //     }
    // }


}
function queueDropTokenMetadata(tokenAddress,tokenId){
    tokenAddress = cleanAddress(tokenAddress);
    tokenId = parseInt(tokenId);
    let queueId = JSON.stringify([tokenAddress,tokenId]);

    if(
        !dropTokenMetadataQueue.includes(queueId)
    ) {
        dropTokenMetadataQueue.splice(1, 0, queueId);
        return true;
    }
    return false;

}
async function fetchDropTokenMetadata(){
    if(dropTokenMetadataQueue.length === 0) return;

    let queueItem = dropTokenMetadataQueue[0];
    let queueData = JSON.parse(queueItem);

    let tokenAddress = cleanAddress(queueData[0]);
    let tokenId = parseInt(queueData[1]);

    // _tokenMetadata[tokenAddress].tokens[tokenId] = {
    //     state: "pending",
    //     uri: "",
    //     name: "",
    //     description: "",
    //     image: "",
    // }
    // tokenMetadata.set(_tokenMetadata);


    // let contract = new ethers.Contract(tokenAddress, contractAbi.ERC721, provider);
    try{
        // _tokenMetadata[tokenAddress].tokens[tokenId].uri
        //
        // let uri = await contract.tokenURI(tokenId);
        // _tokenMetadata[tokenAddress].tokens[tokenId].uri = uri;
        // tokenMetadata.set(_tokenMetadata);


        uriRequest(tokenAddress,tokenId);

        // console.log(metadata);
        // _tokenMetadata[tokenAddress].tokens[tokenId].name        = metadata.name;
        // _tokenMetadata[tokenAddress].tokens[tokenId].description = metadata.description;
        // _tokenMetadata[tokenAddress].tokens[tokenId].image       = metadata.image;
        // tokenMetadata.set(_tokenMetadata);
    }catch(e){
        console.log('metadata fail');
        console.log(e);
        _tokenMetadata[tokenAddress].tokens[tokenId].state = "fail";
    }

    // if(dropTokenMetadataQueue[0] === queueItem){
    //     dropTokenMetadataQueue.splice(0,1);
    //     fetchDropTokenMetadata();
    // }

}
function decode_utf8(s) {
    return decodeURIComponent(escape(s));
}
async function uriRequest(tokenAddress,tokenId){
    let queueItem = JSON.stringify([tokenAddress,tokenId]);
    let uri = _tokenMetadata[tokenAddress].tokens[tokenId].uri;

    // console.log(uri);

    const binary_lead = "data:application/json;base64,";

    if(uri.substr(0,binary_lead.length) === binary_lead){

        try{
            let metadata = JSON.parse(window.atob(uri.substr(binary_lead.length)));

            _tokenMetadata[tokenAddress].tokens[tokenId].name        = decode_utf8(metadata.name);
            _tokenMetadata[tokenAddress].tokens[tokenId].description = decode_utf8(metadata.description);
            _tokenMetadata[tokenAddress].tokens[tokenId].image       = metadata.image;

            _tokenMetadata[tokenAddress].tokens[tokenId].state = "loaded";

            tokenMetadata.set(_tokenMetadata);

            if(dropTokenMetadataQueue[0] === queueItem){
                dropTokenMetadataQueue.splice(0,1);
                fetchDropTokenMetadata();
            }

        }catch(e){
            console.log(e);

            _tokenMetadata[tokenAddress].tokens[tokenId].state = "fail";

            if(dropTokenMetadataQueue[0] === queueItem){
                dropTokenMetadataQueue.splice(0,1);
                fetchDropTokenMetadata();
            }
        }
        return;
    }




    const cors_sidestep = "https://xv4jmp4cff.execute-api.ap-southeast-2.amazonaws.com/live?url="

    var request = new XMLHttpRequest();
    request.open('GET', cors_sidestep+uri, true);  // `false` makes the request synchronous
    // request.withCredentials = true;
    request.send();

    request.onerror = function(err) {
        _tokenMetadata[tokenAddress].tokens[tokenId].state = "fail";
        tokenMetadata.set(_tokenMetadata);

        if(dropTokenMetadataQueue[0] === queueItem){
            dropTokenMetadataQueue.splice(0,1);
            fetchDropTokenMetadata();
        }
    }
    request.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
            try{
                let metadata = JSON.parse(request.responseText);

                _tokenMetadata[tokenAddress].tokens[tokenId].name        = metadata.name;
                _tokenMetadata[tokenAddress].tokens[tokenId].description = metadata.description;
                _tokenMetadata[tokenAddress].tokens[tokenId].image       = metadata.image;

                _tokenMetadata[tokenAddress].tokens[tokenId].state = "loaded";
            }catch(e){
                _tokenMetadata[tokenAddress].tokens[tokenId].state = "fail";
            }
            tokenMetadata.set(_tokenMetadata);

            if(dropTokenMetadataQueue[0] === queueItem){
                dropTokenMetadataQueue.splice(0,1);
                fetchDropTokenMetadata();
            }
        }
    }
}

function queueInitialTokenMetadata(){
    for(let tokenAddress in _tokenMetadata){
        for(let dropTokenId in _tokenMetadata[tokenAddress].tokens){
            _tokenMetadata[tokenAddress].tokens[dropTokenId].state = 'pending';
            requestDropTokenMetadata(tokenAddress,dropTokenId);
        }
    }
}



export default async function init() {
    if(isInjected) return;
    await connect();
}

onInjected(()=>{
    isInjected = true;
    useInfura.set(false);
    state_infura.set("void");

});

export async function connect(){
    if(isInjected) return;
    console.log('non-injected connect..');

    getContractState();

}


async function getContractState(){
    state_infura.set('loading');
    // let uri = "http://localhost:3000/contractState";
    let uri = "https://xv4jmp4cff.execute-api.ap-southeast-2.amazonaws.com/live?url=http://45.32.246.130:3000/contractState";
    var request = new XMLHttpRequest();
    request.open('GET', uri, true);  // `false` makes the request synchronous
    // request.withCredentials = true;
    request.send();

    console.log('test')

    request.onerror = function(err) {
        console.log('error')
        console.log(err)
        state_infura.set('error');
    }
    request.onreadystatechange = function () {

        if (this.readyState == 4 && this.status == 200) {
            try{
                let data = JSON.parse(request.responseText);

                _drops = data.drops;
                drops.set(_drops);

                _pastDrops = data.pastDrops;
                pastDrops.set(_pastDrops);

                _tokenMetadata = data.tokenMetadata;
                tokenMetadata.set(_tokenMetadata);


                console.log("infura loaded");
                console.log(data);

                queueInitialTokenMetadata();

                state_infura.set('loaded');

            }catch(e){
                console.log('error')
                state_infura.set('error');
            }
        }
    }
}

init();